import { Card, CardContent, IconButton, Divider } from "@mui/material"
import { Edit, Delete } from "@mui/icons-material"
import { ProduzioneFileDigitale } from "../types"
import { InlineField } from "./DataField"
import { useTranslation } from "react-i18next"
import useUserCanWriteAndDelete from "../hooks/permissions"
import { useIsMobile } from "../hooks/mobile"
import FormatDate from "./FormatDate"

function FormatTCInOut({ value }: { value: { tcin: string; tcout: string }[] | undefined }) {

  if (!value || value.length === 0) {
    return null
  }

  return (
    <div>
      {value.map((pair, index) => (
        <div key={index}>
          {pair.tcin} - {pair.tcout}
        </div>
      ))}
    </div>
  )
}

type ProduzioneFileDigitaleCardProps = {
  produzione: ProduzioneFileDigitale
  onDelete: (produzione: ProduzioneFileDigitale) => void
  onUpdate: (produzione: ProduzioneFileDigitale) => void
}

export default function ProduzioneFileDigitaleCard({ produzione, onDelete, onUpdate }: ProduzioneFileDigitaleCardProps) {
  const { t, i18n } = useTranslation()
  const userCanWriteAndDelete = useUserCanWriteAndDelete()
  const isMobile = useIsMobile()
  const lang = i18n.language

  return (
    <Card>
      <CardContent sx={{ position: "relative" }}>
        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onUpdate(produzione)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "primary.main",
            }}
            aria-label="edit"
          >
            <Edit />
          </IconButton>
        )}
        <InlineField label={t("fileDigitale.progetto")} value={produzione?.progetto} />
        <InlineField label={t("fileDigitale.tipologia_utilizzo")} value={produzione?.tipologia_utilizzo_data?.termine} />
        <InlineField label={t("fileDigitale.tipo_file")} value={produzione?.tipo_file_data?.termine} />

        <Divider sx={{ marginY: 2 }} />

        <InlineField label={t("fileDigitale.tcin_tcout")} value={<FormatTCInOut value={produzione?.tcin_tcout} />} />

        <Divider sx={{ marginY: 2 }} />

        <InlineField label={t("fileDigitale.note_tecniche")} value={lang === 'it' ? produzione?.note_tecniche_it : produzione?.note_tecniche_en} />
        <InlineField label={t("fileDigitale.referente_archivio")} value={produzione?.referente_archivio} />

        <Divider sx={{ marginY: 2 }} />

        <InlineField label={t("fileDigitale.liberatoria")} value={produzione?.liberatoria} boolean />
        <InlineField label={t("fileDigitale.data_liberatoria")} value={produzione?.data_liberatoria ? <FormatDate>{produzione.data_liberatoria}</FormatDate> : null} />
        <InlineField label={t("fileDigitale.pagamento")} value={produzione?.pagamento} boolean />

        <InlineField label={t("fileDigitale.note")} value={lang === 'it' ? produzione?.note_it : produzione?.note_en} />


        {userCanWriteAndDelete && !isMobile && (
          <IconButton
            onClick={() => onDelete(produzione)}
            sx={{
              position: "absolute",
              bottom: 8,
              right: 8,
              color: "error.main",
            }}
            aria-label="delete"
          >
            <Delete />
          </IconButton>
        )}
      </CardContent>
    </Card>
  )
}
